import { Accordion, Button, Flex, Text } from "@chakra-ui/react";
import { useMutation } from "react-query";
import { NewOrderEarSide, useNewOrderStore } from "../../../stores/order.store";
import { createFile } from "../../../mutations/file.mutations";
import FileInlineInput, {
	type FileInlineInputHandler,
} from "../../../components/FileInlineInput";
import { LeftEar } from "./EarIcons";
import BrandFullCheckIcon from "../../../components/icons/BrandFullCheckIcon";
import { EarSectionType } from "./EarSectionType";
import { EarSectionForm } from "./EarSectionForm";
import { NewOrderEarprintShippingType } from "../../../stores/order.store";
import { useRef } from "react";
import { useSimpleToast } from "../../../hooks/toast.hooks";

export const EarSectionLeft = () => {
	const {
		enableEar,
		hasLeftEar,
		earprintShippingType,
		setFile,
		leftFile,
		isRework,
		reworkCommand,
		copySide,
	} = useNewOrderStore();
	const { error } = useSimpleToast();
	const { earmold, formIndexes } = useNewOrderStore();
	const inputInlineRef = useRef<FileInlineInputHandler>(null);
	const mutateCreateFile = useMutation(createFile);

	return (
		<Flex
			direction="column"
			justifyContent="center"
			border="solid 1px"
			borderColor="gray.200"
			borderTopRadius="xl"
			pt={4}
			pb={hasLeftEar ? 0 : 4}
			bgColor={hasLeftEar ? "#EFF6FF" : undefined}
		>
			<Flex
				position="relative"
				direction="column"
				gap={4}
				alignItems="center"
				onClick={() => {
					if (reworkCommand === undefined) {
						enableEar(NewOrderEarSide.LEFT, !hasLeftEar);
					} else {
						const reworkCommandDraft = reworkCommand.draft;
						if (reworkCommandDraft?.hasLeftEar === true) {
							enableEar(NewOrderEarSide.LEFT, !hasLeftEar);
						}
					}
				}}
			>
				<LeftEar />
				Oreille gauche
				{hasLeftEar && (
					<Flex className="absolute top-2 right-4 flex gap-4 items-center">
						<Text>Déselectionner l'oreille</Text>
						<BrandFullCheckIcon
							w="24px"
							h="24px"
							className="text-brand-600"
							color="text-brand-600"
						/>
					</Flex>
				)}
				{!hasLeftEar && (
					<Flex className="absolute top-2 right-4 flex gap-4 items-center">
						<Text>Sélectionner l'oreille</Text>
						<div className="w-6 h-6 rounded-full border! border-gray-200"></div>
					</Flex>
				)}
			</Flex>

			{hasLeftEar && (
				<Flex direction="column" gap={8} pt={8}>
					<Flex
						direction="column"
						justifyContent="center"
						alignItems="center"
						gap={4}
					>
						<Button
							backgroundColor="white"
							width="fit-content"
							onClick={() => copySide(NewOrderEarSide.RIGHT)}
						>
							Copier les caractéristiques de l'oreille droite
						</Button>
						{earprintShippingType === NewOrderEarprintShippingType.DIGITAL &&
							isRework() === false && (
								<Flex direction="row" justifyContent="center" px={4} w="80%">
									<FileInlineInput
										ref={inputInlineRef}
										name={"leftFile"}
										accept=".stl"
										fileName={leftFile?.fileName}
										files={
											leftFile
												? [
														{
															id: leftFile.id,
															name: leftFile.fileName,
															size: leftFile.fileSize,
														},
													]
												: undefined
										}
										isUploading={mutateCreateFile.isLoading}
										onReset={() => {
											setFile(NewOrderEarSide.LEFT, undefined);
										}}
										onFileChange={async (files: File[] | null) => {
											const reset = () => {
												setFile(NewOrderEarSide.LEFT, undefined);
												if (inputInlineRef.current) {
													inputInlineRef.current.reset();
												}
												error(
													"Fichier d'empreinte",
													"Le nom du fichier d'empreinte doit se terminer par _L.stl",
												);
											};

											if (!Array.isArray(files)) return reset();
											if (files.length === 0) return reset();
											const file = files[0];
											if (!file.name.toLowerCase().endsWith("_l.stl")) {
												reset();
											} else {
												const data = await mutateCreateFile.mutateAsync({
													file,
													fileName: file.name,
												});
												setFile(NewOrderEarSide.LEFT, data);
											}
										}}
									/>
								</Flex>
							)}
					</Flex>
					<Accordion index={formIndexes} backgroundColor="#F8FAFC">
						<EarSectionType />
						{earmold && (
							<>
								<EarSectionForm side={NewOrderEarSide.LEFT} />
							</>
						)}
					</Accordion>
				</Flex>
			)}
		</Flex>
	);
};
